import React from 'react';
import About from '../About/About';
import Contuct from '../Contuct/Contuct';

import Banner from '../Footer/Banner/Banner';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Project from '../MyProject/Project';
import Services from '../Services/Services';
import Skils from '../Skils/Skils';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <Banner></Banner>
            <Services></Services>
            <Skils></Skils>
            <About></About>
            <Project></Project>
            <Contuct></Contuct>
            <Footer></Footer>
        </div>
    );
};

export default Home;